import { PlanBillingType, SubscriptionPlan } from '~/api/graphql';

/**
 * Agencies without customer-facing usage billing see fixed trial allotments for
 * Triggers / Outbound Voice. settingsUsageTabEnabled mirrors usage billing:
 * false for legacy null planBillingType and for PER_SEAT/PLATFORM while
 * usage_dashboard is off. Explicit UNMETERED is unlimited (admin-set) and is
 * excluded.
 */
export const hasLimitedUsageAllotment = (
  subscription:
    | {
        plan?: SubscriptionPlan | null;
        planBillingType?: PlanBillingType | null;
      }
    | null
    | undefined,
  settingsUsageTabEnabled: boolean
): boolean => {
  if (!subscription?.plan) {
    return false;
  }
  if (subscription.planBillingType === PlanBillingType.Unmetered) {
    return false;
  }
  return !settingsUsageTabEnabled;
};
